import { render } from "./WeatherMapLegend.vue?vue&type=template&id=44c3749f"
import script from "./WeatherMapLegend.vue?vue&type=script&lang=js"
export * from "./WeatherMapLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__